import axiosRequest from "@/utils/axiosRequest";

export function detail(data) {
  return axiosRequest({
    url: `/account/detail`,
    data,
    method: "post"
  });
}

export function update(data) {
  return axiosRequest({
    url: `/account/update`,
    data,
    method: "post"
  });
}

export function updatePassword(data) {
    return axiosRequest({
        url: `/account/updatePassword`,
        data,
        method: 'post'
    })
  }

  export function login(data) {
    return axiosRequest({
        url: `/account/login`,
        data,
        method: 'post'
    })
  }
  
  export function getUserInfo(data) {
    return axiosRequest({
        url: `/account/getUserInfo`,
        data,
        method: 'post'
    })
  }

  export function forgetPassword(data) {
    return axiosRequest({
        url: `/account/resetPassword`,
        data,
        method: 'post'
    })
  }